var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import AreaRow from '@/components/area-row/AreaRow';
import SelectFilter from '@/components/select-filter/SelectFilter';
import ErrorHandler from '@/support/ErrorHandler';
import { GlobalUser } from '@/models/GlobalUser';
import { fileToBase64 } from '@/support/String';
import RolesAutocomplete from '@/components/Autocompletes/RolesAutocomplete/RolesAutocomplete';
import Roles, { RolesEnum } from '@/items/Roles';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.currentStep = 1;
        this.isLoading = false;
        this.user = new GlobalUser({
            avatar: '',
            email: '',
            phone: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            roles: '',
        });
        this.importedFile = null;
        this.acceptedValues = [
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ];
        this.role = Roles;
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    get items() {
        return Roles.items.filter((item) => this.acceptedValues.includes(item.id));
    }
    async avatarChanged(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        const file = event.target.files[0];
        this.user.avatar = await fileToBase64(file);
    }
    onImportFileChange(event) {
        if (!event.target.files.length) {
            return;
        }
        this.importedFile = event.target.files[0];
        if (!this.importedFile) {
            return;
        }
        this.goToStep(4);
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    goToStep(number) {
        if (number < 1 || number > 3) {
            return;
        }
        this.currentStep = number;
    }
    nextStep() {
        this.goToStep(this.currentStep + 1);
    }
    prevStep() {
        this.goToStep(this.currentStep - 1);
    }
    // #endregion
    // #region Async methods
    async onClickCreate() {
        this.isLoading = true;
        const payload = this.user.clone();
        payload.roles = [this.user.roles];
        const user = await payload.create().catch((error) => {
            ErrorHandler.network(error);
            this.goToStep(1);
        });
        this.isLoading = false;
        if (user) {
            this.$emit('create');
            this.close();
            return;
        }
        this.nextStep();
    }
};
CreateDialog = __decorate([
    Component({
        components: {
            AreaRow,
            SelectFilter,
            RolesAutocomplete,
        },
    })
], CreateDialog);
export default CreateDialog;
